import { render, staticRenderFns } from "./FormulaList.vue?vue&type=template&id=2e480fa1"
import script from "./FormulaList.vue?vue&type=script&lang=js"
export * from "./FormulaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports